import "@common/jquery.ext";
import {menu} from "@common/menu";
import {ajax} from "@common/ajax";
import {util, validate, fileExtensionFormat} from "@common/util";
import {alert, confirm, message} from "@common/message";
import {MemberService} from "@service/member.service";
import {CompanyService} from "@service/company.service";
import {validateOptions} from "./store";

let mChkIdXhr: any;
let mChkEmailXhr: any;
let mCompanyXhr: any;
$(() => {
    // events
    $(".input-txt").inputChange(onInputChange);
    $("#mbrId").blur(doCheckId);
    $("#email").blur(doCheckEmail);
    $("#brno").enter(getCompanyInfo);
    $("#btnBrno").click(getCompanyInfo);
    $("#chkPolicyAll").click(onCheckPolicyAll);
    $(".chkPolicy").click(onCheckPolicy);
    $("#btnSubmit").click(doSubmit);
    $("#btnCancel").click(menu.goLogin);

    // file selector
    $("#btnBrcFile").selectFile({
        fileId: "#brcUpload",
        labelId: "#brcFile",
        limitSize: 10,
        extensions: [ ...fileExtensionFormat.image, ...fileExtensionFormat.pdf ],
        callback: () => validate.hideMessage("brcFile")
    });

    // init validate
    $("#frmJoin").validate(validateOptions);
});

const onInputChange = (event: any): void => {
    const id = $(event.currentTarget).getId();
    if (id === "brno") {
        $("#chkBrno").val("N");
        $("#coNm").val("");
        $("#coNo").val("0");
        $("#btnBrcFile").selectFile("clear");
        $("#inpBrcFile").addClass("hide");
        validate.hideMessage("coNm");
        validate.hideMessage("brcFile");
    }
    // hide message
    validate.hideMessage(id);
}

const doCheckId = (): void => {
    // init
    const objId = "mbrId";
    const mbrId = $(`#${objId}`).trim().val();
    // clear
    ajax.abort(mChkIdXhr);
    validate.hideMessage(objId);
    // validate
    if (!!!mbrId) {
        validate.showMessage(objId, "아이디를 입력해 주세요.");
    }
    else if (!validate.id(mbrId)) {
        validate.showMessage(objId, "5~20자, 영문/숫자로 입력해 주세요.");
    }
    else {
        mChkIdXhr = MemberService.checkId({
            data: `mbrId=${mbrId}`,
            func: {
                success: (result: any) => {
                    validate.showMessage(objId, "등록 가능합니다.", "valid");
                },
                error: (result: any) => {
                    if (util.equals(result.code, 1)) {
                        validate.showMessage("mbrId", "이미 등록된 아이디입니다.");
                    }
                }
            }
        });
    }
}

const doCheckEmail = (): void => {
    // init
    const objId = "email";
    const email = $(`#${objId}`).trim().val();
    // clear
    ajax.abort(mChkEmailXhr);
    validate.hideMessage(objId);
    // validate
    if (!!!email) {
        validate.showMessage(objId, "이메일을 입력해 주세요.");
    }
    else if (!validate.email(email)) {
        validate.showMessage(objId, "이메일 형식에 맞게 입력해 주세요.");
    }
    else {
        mChkEmailXhr = MemberService.checkEmail({
            data: `email=${email}`,
            func: {
                success: (result: any) => {
                    validate.showMessage(objId, "등록 가능합니다.", "valid");
                },
                error: (result: any) => {
                    if (util.equals(result.code, 1)) {
                        validate.showMessage(objId, "이미 등록된 이메일입니다.");
                    }
                }
            }
        });
    }
}

const getCompanyInfo = (): void => {
    // init
    const objId = "brno";
    const brno = $(`#${objId}`).trim().val();
    // clear
    ajax.abort(mCompanyXhr);
    validate.hideMessage(objId);
    $("#chkBrno").val("N");
    $("#coNo").val("0");
    // validate
    if (!!!brno) {
        validate.showMessage(objId, "사업자등록번호를 입력해 주세요.");
    }
    else if (!validate.brno(brno)) {
        validate.showMessage(objId, "사업자등록번호를 형식에 맞게 입력해 주세요.");
    }
    else {
        mCompanyXhr = CompanyService.getInfo({
            data: `brno=${brno}`,
            func: {
                success: setCompanyInfoResult,
                error: ajax.alertErrorMessage
            }
        });
    }
}

const setCompanyInfoResult = (result: any): void => {
    if (!!result && !!result.info) {
        $("#chkBrno").val("F");
        $("#coNo").val(result.info.coNo);
        $("#coNm").setReadonly(true).val(result.info.coNm);
        $("#btnBrcFile").selectFile("clear");
        $("#inpBrcFile").addClass("hide");
        alert("등록된 사업자입니다.");
    }
    else {
        $("#chkBrno").val("C");
        $("#coNo").val("0");
        $("#coNm").setReadonly(false).val("");
        $("#btnBrcFile").selectFile("clear");
        $("#inpBrcFile").removeClass("hide");
        alert("사업자 정보를 찾을 수 없습니다.<br/>사업자등록증을 업로드해 주세요.");
    }
}

const onCheckPolicyAll = (): void => {
    const check = $("#chkPolicyAll").isCheck();
    $(".chkPolicy").setCheck(check);
}

const onCheckPolicy = (): void => {
    const checkAll = $(".chkPolicy").isCheckAll();
    $("#chkPolicyAll").setCheck(checkAll);
}

const doJoin = (): void => {
    if (isValid()) {
        const isAgreeCheck = $("#emSendYn").isCheck() || $("#atSendYn").isCheck();
        if (isAgreeCheck) {
            doSubmit();
        }
        else {
            confirm("알림 수신을 동의하지 않으시면 주문 및 견적 관련 알림을 받으실 수 없습니다.<br/>회원가입 후 마이페이지에서 변경하실 수 있습니다.<br/>가입을 진행하시겠습니까?", (isConfirmed: boolean) => {
                if (isConfirmed) {
                    doSubmit();
                }
            });
        }
    }
}

const doSubmit = (): void => {
    if (isValid()) {
        message.loading();
        ajax.formDataSubmit({
            url: "./joinProc.do",
            form: "#frmJoin",
            func: {
                success: (result: any) => {
                    alert("USBIO 회원가입 요청이 완료되었습니다.<br/>관리자 인증 이후 이용이 가능합니다.<br/>감사합니다.", menu.goLogin, {icon: "success"});
                },
                error: (result: any) => {
                    if (util.equals(result.code, 1)) {
                        validate.showMessage("mbrId", "이미 등록된 아이디입니다.");
                    } else if (util.equals(result.code, 2)) {
                        validate.showMessage("email", "이미 등록된 이메일입니다.");
                    } else {
                        ajax.alertErrorMessage(result);
                    }
                }
            }
        });
    }
}

const isValid = (): boolean => {
    let valid = $("#frmJoin").formTrim().valid();
    if (valid) {
        if (!$("#chkPolicyService").isCheck()) {
            valid = false;
            alert("이용약관에 동의해 주세요.");
        }
        else if (!$("#chkPolicyPrivacy").isCheck()) {
            valid = false;
            alert("개인정보 수집 및 이용에 동의해 주세요.");
        }
    }
    return valid;
}

